import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, Form, FormGroup } from 'reactstrap';
import FormFooter from '../../../../common/forms/FormFooter';
import SelectionableTable from '../../../../common/forms/table/SelectionableTable';
import {
  DEFAULT_PAGE_SIZE,
  NEW_BAGGAGE_ITEM_STATUS,
} from '../../../../../config/constants';
import { generateBaggageItemManifestColumns } from '../../../../../config/columns';
import { filterMethodCaseInsensitive } from '../../../../../utils/filter-methods';
import FormItem from '../../../../common/forms/FormItem';
import TextInput from '../../../../common/forms/input/TextInput';
import { isRequired } from '../../../../../utils/validators';

const BaggageManifestDestinationMismatchModal = ({
  handleSubmit,
  onCancel,
  items,
  itineraryId,
  onSubmit,
  locationId,
}) => {
  const statusOptions = useMemo(
    () =>
      [...new Map(items.map(({ status }) => [status, status])).values()].map(
        (status) => ({
          value: status,
          label: NEW_BAGGAGE_ITEM_STATUS[status]
            ? NEW_BAGGAGE_ITEM_STATUS[status].label
            : status,
        }),
      ),
    [items],
  );

  const sourceOptions = useMemo(
    () =>
      [
        ...new Map(
          items.map(({ sourceLocation }) => [
            sourceLocation.id,
            sourceLocation,
          ]),
        ).values(),
      ].map(({ id, name }) => ({ value: id, label: name })),
    [items],
  );

  const destinationOptions = useMemo(
    () =>
      [
        ...new Map(
          items.map(({ destinationLocation }) => [
            destinationLocation.id,
            destinationLocation,
          ]),
        ).values(),
      ].map(({ id, name }) => ({ value: id, label: name })),
    [items],
  );

  const columns = useMemo(
    () =>
      generateBaggageItemManifestColumns(
        sourceOptions,
        destinationOptions,
        statusOptions,
      ),
    [sourceOptions, destinationOptions, statusOptions],
  );

  const onHandleSubmit = (formValues) => {
    onSubmit({ ...formValues, itineraryId, locationId });
  };

  return (
    <Form onSubmit={handleSubmit(onHandleSubmit)}>
      <h5>Equipajes: </h5>
      <SelectionableTable
        columns={columns}
        data={items}
        defaultPageSize={DEFAULT_PAGE_SIZE}
        keyField="id"
        form="BaggageManifestDestinationMismatchModal"
        returnOnlySelectedItems
        filterable
        defaultFilterMethod={filterMethodCaseInsensitive}
      />
      <br />
      <FormGroup row>
        <FormItem label="Comentario" required>
          <Field
            name="comment"
            component={TextInput}
            type="textarea"
            placeholder="Comentario"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormFooter>
        <Button color="secondary" onClick={onCancel}>
          Cancelar
        </Button>
      </FormFooter>
    </Form>
  );
};

BaggageManifestDestinationMismatchModal.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  itineraryId: PropTypes.number.isRequired,
  onSubmit: PropTypes.func.isRequired,
  locationId: PropTypes.number.isRequired,
};

BaggageManifestDestinationMismatchModal.defaultProps = {};

export default reduxForm({
  form: 'BaggageManifestDestinationMismatchModal',
})(BaggageManifestDestinationMismatchModal);
